import { DateTime } from "luxon";

export function toTimestamp(datefield: Date, timefield: string, timezone: string): DateTime | null {
    const date = datefield ? DateTime.fromJSDate(datefield).startOf('day') : null;
    const time = timefield?.split(':').map(t => parseInt(t || '0', 10)) ?? [0, 0];
    return date?.set({ hour: time[0], minute: time[1] })
        .setZone(timezone, { keepLocalTime: true }) ?? null;
}

